import * as React from 'react';

type VolumeDownSvgProps = React.SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
};

const VolumeDownSvg: React.FC<VolumeDownSvgProps> = ({ width = 28, height = 28, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      {...props}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="VolumeDownSvg"
    >
      <path
        d="M10.5002 17.4999H7.00016C6.66961 17.4999 6.39252 17.3881 6.16891 17.1645C5.9453 16.9409 5.8335 16.6638 5.8335 16.3332V11.6666C5.8335 11.336 5.9453 11.0589 6.16891 10.8353C6.39252 10.6117 6.66961 10.4999 7.00016 10.4999H10.5002L14.3502 6.64989C14.7196 6.28045 15.1425 6.19781 15.6189 6.40197C16.0953 6.60614 16.3335 6.97072 16.3335 7.49572V20.5041C16.3335 21.0291 16.0953 21.3936 15.6189 21.5978C15.1425 21.802 14.7196 21.7193 14.3502 21.3499L10.5002 17.4999ZM21.5835 13.9999C21.5835 14.8166 21.3988 15.5895 21.0293 16.3186C20.6599 17.0478 20.1738 17.6457 19.571 18.1124C19.3766 18.2291 19.1772 18.2339 18.9731 18.127C18.7689 18.02 18.6668 17.8499 18.6668 17.6166V10.3249C18.6668 10.0916 18.7689 9.92142 18.9731 9.81447C19.1772 9.70753 19.3766 9.71239 19.571 9.82906C20.1738 10.3152 20.6599 10.9277 21.0293 11.6666C21.3988 12.4054 21.5835 13.1832 21.5835 13.9999ZM14.0002 10.3249L11.4918 12.8332H8.16683V15.1666H11.4918L14.0002 17.6749V10.3249Z"
        fill="white"
      />
    </svg>
  );
};

export default VolumeDownSvg;
